import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true
})
export class SdHighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value?: string, searchTerm?: string): SafeHtml {
    if (!value || !searchTerm) {
      return value;
    }
    // Match in a case insensitive maneer
    const safeSearchTerm = searchTerm.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
    const re = new RegExp(safeSearchTerm, 'gi');
    const replacedValue = value.replace(re, (match) => `<mark>${match}</mark>`);

    return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
  }
}
